import {
  ADD_NEW_USER_FAILED,
  ADD_NEW_USER_REQUEST,
  ADD_NEW_USER_SUCCESS,
  CLEAR_ADMIN_RESPONSE,
  DELETE_USER_FAILED,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  EDIT_CRADICIALS_FAILED,
  EDIT_CRADICIALS_REQUEST,
  EDIT_CRADICIALS_SUCCESS,
  GET_CRADICIALS_FAILED,
  GET_CRADICIALS_REQUEST,
  GET_CRADICIALS_SUCCESS,
  GET_LOGGER_DATA_FAILED,
  GET_LOGGER_DATA_REQUEST,
  GET_LOGGER_DATA_SUCCESS,
  GET_USERS_LIST_FAILED,
  GET_USERS_LIST_REQUEST,
  GET_USERS_LIST_SUCCESS,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DUPLICATE_USER_REQUEST,
  DUPLICATE_USER_SUCCESS,
  DUPLICATE_USER_FAILED,
  GET_USER_PERMISSION_DATA_SUCCESS,
  GET_USER_PERMISSION_DATA_REQUEST,
  GET_USER_PERMISSION_DATA_FAILED,
  UPLOAD_DOMAIN_WHITELIST_FAILED,
  UPLOAD_DOMAIN_WHITELIST_SUCCESS,
  UPLOAD_DOMAIN_WHITELIST_REQUEST,
  UPLOAD_APP_WHITELIST_REQUEST,
  UPLOAD_APP_WHITELIST_SUCCESS,
  UPLOAD_APP_WHITELIST_FAILED,
  GET_DOMAINWHITELIST_CSV_DATA_REQUEST,
  GET_DOMAINWHITELIST_CSV_DATA_SUCCESS,
  GET_DOMAINWHITELIST_CSV_DATA_FAILED,
  GET_APPWHITELIST_CSV_DATA_REQUEST,
  GET_APPWHITELIST_CSV_DATA_SUCCESS,
  GET_APPWHITELIST_CSV_DATA_FAILED,
  DELETE_WHITELIST_CJSC_REQUEST,
  DELETE_WHITELIST_CJSC_FAILED,
  DELETE_WHITELIST_CJSC_SUCCESS,
  REMOVE_USER_TOKEN_REQUEST,
  REMOVE_USER_TOKEN_SUCCESS,
  REMOVE_USER_TOKEN_FAILED,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILED,
  CLEARALL_NOTIFICATIONS_SUCCESS,
  UPDATE_NOTIFICATION_READ_COUNT,
  C_GET_ADVERTISER_REQUEST,
  C_GET_ADVERTISER_SUCCESS,
  C_GET_ADVERTISER_FAILED,
  C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST,
  C_ADMIN_GET_S3FILESANDFOLDERS_SUCCESS,
  C_ADMIN_GET_S3FILESANDFOLDERS_FAILED,
  GET_NOAS_COUNTER_REQUEST,
  GET_NOAS_COUNTER_SUCCESS,
  GET_NOAS_COUNTER_FAILED,
} from "../Actions/AdminActions";

const InitialState = {
  loading: false,
  userList: [],
  adv: [],
  s3Files: [],
  s3Folders: [],
  craditials: {},
  success: false,
  notificationList: [],
  notification_read_count: 0,
  noas: [],
};

export const AdminReducer = (state = InitialState, action: any) => {
  switch (action.type) {
    case C_GET_ADVERTISER_REQUEST:
      return {
        ...state,
        loading: true
      };
    case C_GET_ADVERTISER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        adv: action.payload
      };
    case C_GET_ADVERTISER_FAILED:
      return {
        ...state,
        loading: false,
        success: false
      };
      case C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST:
        return {
            ...state,
            loading: true
        };
    case C_ADMIN_GET_S3FILESANDFOLDERS_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            s3Files: action.payload.files,
            s3Folders: action.payload.folders,
            curFolder:action.payload.curFolder
        };
    case C_ADMIN_GET_S3FILESANDFOLDERS_FAILED:
        return {
            ...state,
            loading: false,
            success: false
        };
    case GET_LOGGER_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_LOGGER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case GET_LOGGER_DATA_FAILED:
      return {
        ...state,
        loading: false,
      };

    case GET_USERS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userList: action.payload,
      };

    case GET_USERS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        userList: action.payload,
      };

    case GET_CRADICIALS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_CRADICIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        craditials: action.payload,
      };

    case GET_CRADICIALS_FAILED:
      return {
        ...state,
        loading: false,
        craditials: action.payload,
      };

    case EDIT_CRADICIALS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case EDIT_CRADICIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };

    case EDIT_CRADICIALS_FAILED:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case ADD_NEW_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_USER_SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };
    case ADD_NEW_USER_FAILED:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };
    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };
    case DELETE_USER_FAILED:
      return {
        ...state,
        success: false,
        loading: false,
      };
    case CLEAR_ADMIN_RESPONSE:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case EDIT_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        userList: action.payload,
      };
    case EDIT_USER_FAILED:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };
    case DUPLICATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DUPLICATE_USER_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        userList: action.payload,
      };
    case DUPLICATE_USER_FAILED:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };
    case GET_USER_PERMISSION_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_PERMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_USER_PERMISSION_DATA_FAILED:
      return {
        ...state,
        loading: false,
      };
    case UPLOAD_DOMAIN_WHITELIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_DOMAIN_WHITELIST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPLOAD_DOMAIN_WHITELIST_FAILED:
      return {
        ...state,
        loading: false,
      };
    case UPLOAD_APP_WHITELIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_APP_WHITELIST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPLOAD_APP_WHITELIST_FAILED:
      return {
        ...state,
        loading: false,
      };
    case GET_DOMAINWHITELIST_CSV_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOMAINWHITELIST_CSV_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_DOMAINWHITELIST_CSV_DATA_FAILED:
      return {
        ...state,
        loading: false,
      };
    case GET_APPWHITELIST_CSV_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_APPWHITELIST_CSV_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_APPWHITELIST_CSV_DATA_FAILED:
      return {
        ...state,
        loading: false,
      };
    case DELETE_WHITELIST_CJSC_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_WHITELIST_CJSC_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_WHITELIST_CJSC_FAILED:
      return {
        ...state,
        loading: false,
      };
    case REMOVE_USER_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_USER_TOKEN_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };
    case REMOVE_USER_TOKEN_FAILED:
      return {
        ...state,
        success: false,
        loading: false,
      };
    case GET_NOTIFICATIONS_REQUEST:
      return {
        ...state,
      };
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationList: action?.payload,
      };
    case GET_NOTIFICATIONS_FAILED:
      return {
        ...state,
      };
    case CLEARALL_NOTIFICATIONS_SUCCESS:
      localStorage.removeItem("notification_read_count");
      return {
        ...state,
        notificationList: action?.payload,
        loading: false,
        notification_read_count: 0,
      };
    case UPDATE_NOTIFICATION_READ_COUNT:
      localStorage.setItem("notification_read_count", action?.payload);
      return {
        ...state,
        notification_read_count: action?.payload,
      };
      case GET_NOAS_COUNTER_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_NOAS_COUNTER_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          noas:action.payload
        };
      case GET_NOAS_COUNTER_FAILED:
          return{
              ...state,
              loading:false,
              success:false
          };  
    default:
      return state;
  }
};
